import { useAuthDispatch } from 'src/contexts/authContext'

const useHeaderApi = () => {
  const dispatch = useAuthDispatch()

  const logout = async () => {
    dispatch({ type: 'LOGOUT' })
    dispatch({ type: 'EXTERNALWALLET', payload: false })
  }

  return { logout }
}

export default useHeaderApi
